export default "__VITE_ASSET__DtDM8Q$L__"